var modModal = function(){
    var scope = ".js-mod-modal";
    ui.ready(scope,function($mod){
        var $closeModal = $mod.find(scope+"__close-modal");
        $closeModal.click(
            function(ev){
                ev.preventDefault();
                $mod.hide();
            }
        );
    });
}();